import { getFeatureConfig } from '@luna/feature-config';
import { getSessionId } from '@shared/statistics';

export function appendQueryString(
    existingQueryString: string,
    additionalQueryString: string,
): string {
    return [existingQueryString, additionalQueryString].filter(Boolean).join('&');
}

export function addAccessTokenToUrl(url: URL, accessToken: string): void {
    url.hash = appendQueryString(url.hash, `access_token=${accessToken}`);
}

export const getSessionIdOrUndefined = (): string | undefined => {
    if (!getFeatureConfig(({ handover }) => handover.sessionId)) {
        return undefined;
    }

    return getSessionId();
};
